
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_7611_22992)"}},[_c('rect',{attrs:{"x":"6","y":".466","width":"22","height":"21.885","rx":"10.942","fill":"#FFAE80"}})]),_c('path',{attrs:{"d":"M15.04 11.496V9.693A1.97 1.97 0 0117 7.714a1.97 1.97 0 011.959 1.98v1.802m-4.408 0h4.898c.542 0 .98.45.98 1.008v2.773a.992.992 0 01-.98 1.009H14.55a.992.992 0 01-.98-1.009v-2.773a.992.992 0 01.98-1.008z","stroke":"#fff"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_7611_22992","x":"0","y":".466","width":"34","height":"38.885","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feMorphology',{attrs:{"radius":"6","in":"SourceAlpha","result":"effect1_dropShadow_7611_22992"}}),_c('feOffset',{attrs:{"dy":"11"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"6"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.996078 0 0 0 0 0.435294 0 0 0 0 0.380392 0 0 0 0.5 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_7611_22992"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_7611_22992","result":"shape"}})])])])
          )
        }
      }
    